import React, { PureComponent } from 'react'
import Recaptcha from 'react-recaptcha'
import { Link, Redirect } from 'react-router-dom'
import ErrorMessage from '../Messages/errorMessage.jsx';
import InputInitialForm from '../Forms/inputOfInitialForm.jsx';
import CommonFetch from '../../requests/commonFetch'

export default class SignIn extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            captcha: true,
            email: '',
            password: '',
            errorMessage: '',
        }

        this.arrayOfErrorMessage = {
            already_exist: 'Already exist',
            not_registered: 'Not registered',
            investor_unavailable: 'Investor unavailable',
            reached_attempts_limit: 'Reached attempts limit, wait a minute',
            wrong_credentials: 'Wrong credentials',
            wrong_captcha: 'Wrong captcha',
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]

        this.errorMessage = React.createRef();
    }

    componentDidMount() {
        this.checkValueInputs()
    }

    viewCaptcha = () => {
        if (!this.props.captchaKey || !this.state.captcha) return null

        return (
            <Recaptcha
                sitekey={`${this.props.captchaKey}`}
                ref={e => (this.recaptcha = e)}
                render="explicit"
                theme="dark"
                size="normal"
                badge="inline"
                hl={localStorage.language}
            />
        )
    }

    sendFromAuthorization = event => {
        event.preventDefault()
        let form = event.target,
            inputs = form.querySelectorAll(
                'input[type=text], input[type=password]'
            ),
            valid = true

        inputs.forEach(item => {
            if (!item.value) {
                valid = false
            }
            this.checkValidInput(item)
        })

        if (valid) {
            CommonFetch({
                path: 'ui/auth/post_login',
                method: 'POST',
                data: new FormData(form),
            }).then(data => {
                if (data.success) {
                    this.props.switchSignIn()
                } else if (data.error === 'already_logged_in') {
                    this.props.switchSignIn()
                } else {
                    this.recaptcha.reset()
                    this.setState({
                        errorMessage: this.arrayOfErrorMessage[data.error],
                    })
                    this.errorMessage.current.showMessage()
                }
            })
        }

    }

    removeAttrReadOnly = event => {
        let inputs = event.target.parentNode.querySelectorAll('input')
        inputs.forEach(item => {
            item.removeAttribute('readonly')
        })
    }

    checkValidInput = event => {
        let input = event.tagName === 'INPUT' ? event : event.target
        input.setCustomValidity('')
        if (!input.validity.valid) {
            input.setCustomValidity(this.translation['fill this field'])
        }
    }

    inputFocus = event => {
        let elem = event.target,
            input =
                elem.tagName === 'INPUT'
                    ? elem
                    : elem.parentNode.querySelector('input')

        input.removeAttribute('readonly')
        input.classList.add('active')
        input.focus()
    }

    checkValueInputs = () => {
        let inputs = document.querySelectorAll(
            'form input[type=text], form input[type=password]'
        )
        inputs.forEach(item => {
            if (item.value) item.classList.add('active')
            else item.classList.remove('active')
        })
    }

    render() {
        const { from } = this.props.location.state || {
            from: { pathname: '/' },
        }

        if (this.props.signIn) {
            return <Redirect to={from} />
        }

        return (
            <div className="signInContainer">
                <h1 className="signInContainer_header">
                    {this.translation['Cryptaur wallet authorization']}
                </h1>
                <hr />
                <div className="signInContainer_main">
                    <form
                        method="post"
                        className="signInContainer_main_form"
                        onInvalid={this.checkValidInput}
                        onSubmit={this.sendFromAuthorization}
                    >
                        <div className="signInContainer_main_form_email">
                            <InputInitialForm
                                type="text"
                                name="email"
                                title={this.translation['fill this field']}
                            />
                            <span onClick={this.inputFocus}>Email</span>
                        </div>
                        <div className="signInContainer_main_form_password">
                            <InputInitialForm
                                type="password"
                                name="password"
                                title={this.translation['fill this field']}
                            />
                            <span onClick={this.inputFocus}>
                                {this.translation['Password']}
                            </span>
                        </div>
                        {this.viewCaptcha()}
                        <input
                            className="signInContainer_main_form_login"
                            type="submit"
                            value={this.translation['Login']}
                            onClick={this.removeAttrReadOnly}
                        />
                    </form>
                    <div className="signInContainer_main_additions">
                        <Link to="/recover">
                            <div className="signInContainer_main_additions_forgot-password">
                                {this.translation['Forgot your password?']}
                            </div>
                        </Link>
                        <Link to="/registration">
                            <div className="signInContainer_main_additions_account-registration">
                                {this.translation['Haven’t registered yet?']}
                            </div>
                        </Link>
                    </div>
                </div>
                <ErrorMessage
                    ref={this.errorMessage}
                    errorMessage={this.state.errorMessage}
                />
            </div>
        )
    }
}
